<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{ title }}</h1>
      <v-card :class="classPadding">
        <v-row>
          <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
            <v-alert
              border="top"
              color="red lighten-2"
              dark
              dismissible
              v-model="showError"
            >
              <v-row v-for="(err, key) in errors" :key="key">
                <v-col :class="classPadding">
                  <span>• {{ err }}</span>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
        </v-row>
      </v-card>

      <v-row>
        <v-col cols="12" xs="12" sm="6" md="6">
          <v-file-input
            label="Import file"
            :class="classPadding"
            v-model="file"
          ></v-file-input>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="4">
          <v-btn outlined :loading="isUploading" @click.prevent="upload"
            >Upload</v-btn
          >&nbsp;
          <v-btn
            color="success"
            outlined
            :loading="isSaving"
            @click.prevent="save"
            :disabled="hasError"
            v-if="userAccess.submit >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>

      <v-card>
        <v-tabs dark show-arrows background-color="primary" v-model="tab">
          <v-tabs-slider></v-tabs-slider>

          <v-tab v-for="item in items" :key="item.tab">
            <span class="caption">{{ item.tab }}</span>
          </v-tab>
          <v-tabs-items v-model="tab">
            <!-- <v-tab-item v-for="item in items" :key="item.tab">
              <v-card flat>
                <v-card-text>{{ item.content }}</v-card-text>
              </v-card>
            </v-tab-item>-->
            <v-tab-item>
              <v-card flat>
                <emp-info
                  :items="empInfoList"
                  :properties="properties"
                ></emp-info>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <basic-salary
                  :items="basicSalaryList"
                  :properties="properties"
                ></basic-salary>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <allowance
                  :items="allowanceList"
                  :properties="properties"
                ></allowance>
              </v-card>
            </v-tab-item>

            <v-tab-item>
              <v-card flat>
                <earning
                  :items="earningList"
                  :properties="properties"
                ></earning>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
      <span class="caption" :class="classPadding">
        Click [
        <a @click="downloadFile">here</a>] to download the format.
      </span>
    </v-container>
  </div>
</template>
<script>
import userAccessMixin from "../../../mixins/userAccessMixin";
const EmpInfo = () => import("./EmpInfo");
const BasicSalary = () => import("./BasicSalary");
const Allowance = () => import("./Allowance");
const Earning = () => import("./Earning");
const API_ENDPOINT = "/api/importpme";
export default {
  metaInfo: {
    title: "Import Personnel Movement History",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins: [userAccessMixin],
  data: () => ({
    title: "Import Personnel Movement History",
    classPadding: "my-0 py-0",
    isUploading: false,
    isSaving: false,
    tab: null,
    items: [
      { tab: "Employment Info", content: "Tab 1 Content" },
      { tab: "Basic Salary", content: "Tab 2 Content" },
      { tab: "Allowances", content: "Tab 3 Content" },
      { tab: "Earnings", content: "Tab 4 Content" }
    ],
    uploadedItems: null,
    properties: [],
    file: null,
    errors: [],
    showError: false,
    empInfoList: [],
    basicSalaryList: [],
    allowanceList: [],
    earningList: []
  }),
  computed: {
    hasError() {
      if (this.file === null && this.errors.length <= 0) return true;

      if (!(this.empInfoList.length > 0)) return true;

      return this.errors.length > 0 ? true : false;
    }
  },
  methods: {
    upload() {
      this.isUploading = true;
      var formData = new FormData();
      formData.append("file", this.file);

      this.$axios({
        method: "POST",
        url: `${API_ENDPOINT}/upload`,
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      })
        .then(({ data }) => {
          if (data.errors.length > 0) {
            this.errors = data.errors;
            this.properties = data.properties;
          } else {
            this.errors = [];
            this.properties = [];
          }
          this.uploadedItems = data;
          this.empInfoList = data.empInfo;
          this.basicSalaryList = data.basicSalaries;
          this.allowanceList = data.allowances;
          this.earningList = data.earnings;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUploading = false;
        });
    },
    downloadFile() {
      var subPath = process.env.VUE_APP_PATH;

      window.open(
        `${subPath.slice(
          0,
          -1
        )}/Files/downloads/Personnel Movement Of Employee History.xlsx`
      );
    },
    save() {
      this.isSaving = true;
      this.$axios
        .post(`${API_ENDPOINT}/save`, this.uploadedItems)
        .then(() => {
          this.$toast.success("Record Successfully Uploaded");
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false;
        });
    },
    reset() {
      this.empInfoList = [];
      this.basicSalaryList = [];
      this.allowanceList = [];
      this.earningList = [];
      this.uploadedItems = null;
      this.file = null;
    }
  },
  components: {
    EmpInfo,
    BasicSalary,
    Allowance,
    Earning
  },
  watch: {
    errors(val) {
      if (val.length > 0) this.showError = true;
      else this.showError = false;
    }
  },
  created() {
    this.getUserAccessRights("IUMASTERH");
  }
};
</script>